import { toast } from "react-toastify";
import React, { useEffect, useState, useRef } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import { Dropdown, Tab, Tabs } from "react-bootstrap";
import { UserHelper } from "@/app/core/util/helpers/UserHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { ComplainController } from "@/app/core/base/controllers/ComplainController";
import { CompanyController } from "@/app/core/base/controllers/CompanyController";
import { CnpjMask, OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { FileController } from "@/app/core/base/controllers/FileController";
import Field from "@/app/core/layouts/main-components/input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import ComplainEditModal from "@/app/modules/administrator/complains/main/components/ComplainEditModal";
import { ComplainHelper } from "@/app/core/util/helpers/ComplainHelper";
import { TimelineController } from "@/app/core/base/controllers/TimelineController";
import Storage from "@/app/core/util/Storage";
import { EmailController } from "@/app/core/base/controllers/EmailController";
import AdminCompanyModal from "@/app/modules/administrator/companies/main/components/AdminCompanyModal";
import { CompanyHelper } from "@/app/core/util/helpers/CompanyHelper";
import { ServicesController } from "@/app/core/base/controllers/ServicesController";
import CheckMobile from "@/app/core/util/Screen";

export default function ComplainModal({ show, onHide, infos }) {
    const [loading, setLoading] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEditCompanyModal, setShowEditCompanyModal] = useState(false);
    const [data, setData] = useState({});
    const [timeline, setTimeline] = useState([]);
    const userData = Storage.getUserData();
    const [order, setOrder] = useState({});
    const [selectedServices, setSelectedServices] = useState([]);

    const date = new Date();
    const [change, setChange] = useState(date.getTime());

    function notifyChange() {
        setChange(date.getTime());
    }

    useEffect(() => {
        if (show && infos && infos.id) {
            setData(infos);
            if (infos && infos.orderId) {
                loadOrder();
            }
            if (infos && infos.selectedServices) {
                loadSelectedServices(infos.selectedServices);
            }
            console.log("My Complaim", infos)
            loadTimeline()
        } else {
            setData({});
        }
    }, [show, infos]);

    async function loadOrder() {
        console.log("Carregou");
        await ComplainController.GetOrder(infos.orderId, neworder => {
            console.log("Order", neworder, infos.orderId);
            if (neworder) {
                setOrder(neworder)
            }
        });

    }

    async function loadInfos() {
        ComplainController.Get(infos.id, async res => {
            const company = await CompanyController.Get(res.companyId);
            const user = await AccountController.GetUser(res.userId);
            setData({ ...res, company, user })
        });
        loadTimeline()
    }

    async function loadTimeline() {
        const res = await TimelineController.List(infos.id);
        res.sort(function (a, b) {
            return b.createdDate.seconds - a.createdDate.seconds;
        });
        console.log("Dados", res);
        setTimeline(res);
    }

    async function loadSelectedServices(serviceIds) {
        const services = await ServicesController.ListSelectedServices(serviceIds);
        setSelectedServices(services);
    }

    async function save() {
    }

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    function processLink(phone) {
        let newPhone = phone.replace("-", "");
        newPhone = newPhone.replace(" ", "");
        newPhone = newPhone.replace("(", "");
        newPhone = newPhone.replace(")", "");    
        return `https://api.whatsapp.com/send?phone=55${newPhone}`;
    }

    async function updateStatus(sts) {
        if (window.confirm(Message.Confirm)) {
            let newData = data;
            newData.status = sts;
            await ComplainController.Update(newData)

            setData(newData);

            let message = `${userData.name} alterou o status para `;

            if (sts === ComplainHelper.Status.Open) {
                message += `Aberto`;
                sendEmail(1);
                if (data.company && data.company.status === CompanyHelper.Status.Pending) {
                    let newCompany = data.company;
                    newCompany.status = CompanyHelper.Status.Approved;
                    await CompanyController.Update();
                }
            } else if (sts === ComplainHelper.Status.Pending) {
                message += `Bloqueado`;
            } else if (sts === ComplainHelper.Status.Pending) {
                message += `Aberto`;
            } else if (sts === ComplainHelper.Status.Deleted) {
                message += `Excluído`;
            }


            timelineRegistry(message);

            notifyChange();
        }
    }

    async function timelineRegistry(description) {
        await TimelineController.Insert({
            complainId: data.id,
            description,
        });

        loadTimeline()
    }

    function sendEmail(send) {
        if (send === 1) {
            //SendAll
            EmailController.SendCompanyComplain(data);
            EmailController.SendUserComplain(data);
            timelineRegistry(`${userData.name} enviou os emails para o cliente e para a empresa`)
        }
        if (send === 2) {
            //SendCustomer
            EmailController.SendUserComplain(data);
            timelineRegistry(`${userData.name} enviou o email para o cliente`)
        }
        if (send === 3) {
            //SendCompany
            EmailController.SendCompanyComplain(data);
            timelineRegistry(`${userData.name} enviou o email para a empresa`)
        }
    }

    function deleteImage(item, index) { }
    function formatCPF(cpf) {
        // Remove any non-numeric characters
        cpf = cpf.replace(/\D/g, '');
    
        // Format the CPF
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
        cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    
        return cpf;
    }

    return (
        <Modal
            title={`Reclamação - ${data && !data.oldId && data.createdDate && data.createdDate.seconds ? data.createdDate.seconds : data.oldId}`}
            show={show}
            onHide={onHide}
            isLoading={loading}
            onSubmit={() => save()}
        >

            <Tabs
                defaultActiveKey="resumo"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="resumo" title="Resumo" className="block-content">

                    <div class="row mb-5">
                        <div class="col-md-6">
                            <p class="h3">Cliente</p>
                            <p>
                                Nome: {data && data.user && data.user.name}<br />
                                E-mail: {data && data.user && data.user.email}<br />
                                {data && data.user && data.user.document && `CPF: ${formatCPF(data.user.document)}`}<br />
                                Telefone: <a href={data && data.phone && processLink(data.phone)} target="_blank"><i className="fab fa-whatsapp text-success" /> {data && data.phone && data.phone}</a> <br />
                                id: {data && data.user && data.user.uid}
                            </p>
                        </div>

                        <div class={`col-md-6 text-${CheckMobile() ? "left":"right"}`}>
                            <p class="h3">Empresa</p>
                            <p>
                                Nome:{data && data.company && data.company.name}<br />
                                E-mail: {data && data.company && data.company.email}<br />
                                {data && data.company && CnpjMask(data.company.taxId)}<br />
                                id: {data && data.company && data.company.id}<br />

                                <button className="btn btn-dual border border-dark" onClick={() => setShowEditCompanyModal(true)}><i className="far fa-edit" /> Editar empresa</button>
                            </p>
                        </div>
                    </div>
                    <hr />
                    <div className="content-heading">
                        <h4 className="text-muted">{data && data.title}</h4>
                    </div>
                    <p style={{ whiteSpace: "pre-line" }}>
                        {data && data.description}
                    </p>

                    <div className="row">
                        {data && data.images && data.images.length > 0 ? <div className="col-md-12">Imagens</div> : ""}
                        {data && data.images && data.images.map((item, index) => (
                            <div class="block block-rounded block-fx-pop col-md-4">
                                <div class="block-content p-0 overflow-hidden">
                                    <a class="img-link img-fluid-100" data-toggle="layout" data-action="side_overlay_open" href="javascript:void(0)">
                                        <img class="img-fluid rounded-top" src={item.url} />
                                    </a>
                                </div>
                                <div class="block-content">
                                    <span class="font-size-sm text-muted">{item.name}</span>
                                </div>
                                {/* <div class="block-content block-content-full">
                            <div class="row">
                                <div class="col-12 text-center">
                                    <a class="btn btn-sm btn-hero btn-noborder btn-secondary btn-block" data-toggle="layout" data-action="side_overlay_open" href="javascript:void(0)">
                                        View
                                    </a>
                                </div>
                            </div>
                        </div> */}
                            </div>
                        ))}
                    </div>


                    {order && order.status ?
                        <div className="block block-fx-pop block-bordered border-info mt-5">
                            <div className="block-header">

                                <div className="block-title">
                                    <i className="far fa-check-circle text-info mr-2" /> Status de pagamento: {order && order.status}
                                </div>
                                <div className="block-tools">

                                </div>
                            </div>
                        </div>
                        : ""}

                    <span className="mt-5">Ações</span>

                    <div className="row">
                        <div className="col-md-3">
                            {change && data && data.status === ComplainHelper.Status.Pending ?
                                <button className="btn btn-danger btn-block" onClick={() => updateStatus(ComplainHelper.Status.Open)}><i className="si si-check" /> Bloqueado (Liberar?)</button>
                                : data && data.status === ComplainHelper.Status.Open ?
                                    <button className="btn btn-success btn-block" onClick={() => updateStatus(ComplainHelper.Status.Pending)}><i className="si si-check" /> Liberado (Bloquear?)</button>
                                    : data && data.status === ComplainHelper.Status.Deleted ?
                                        <button className="btn btn-warning btn-block" onClick={() => updateStatus(ComplainHelper.Status.Pending)}><i className="si si-check" /> Excluído (Restaurar?)</button>
                                        : ""
                            }
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-secondary btn-block" onClick={() => setShowEditModal(true)}><i className="far fa-edit" /> Editar reclamação</button>
                        </div>
                        <div className="col-md-3">
                            <Dropdown>
                                <Dropdown.Toggle className="btn btn-block">Enviar E-mails</Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <button className="btn btn-block btn-hero-sm btn-hero-secondary" onClick={() => sendEmail(1)}><i className="si si-envelope-letter" /> Enviar para todos</button>
                                    <br />
                                    <button className="btn btn-block btn-hero-sm btn-hero-info" onClick={() => sendEmail(2)}><i className="si si-envelope-letter" /> Enviar para cliente</button>
                                    <br />
                                    <button className="btn btn-block btn-hero-sm btn-hero-warning" onClick={() => sendEmail(3)}><i className="si si-envelope-letter" /> Enviar para empresa</button>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="col-md-3">
                            <button className="btn btn-danger btn-block" onClick={() => updateStatus(ComplainHelper.Status.Deleted)}><i className="si si-trash" /> Excluir</button>
                        </div>
                    </div>
                </Tab>
                <Tab eventKey="services" title="Serviços Selecionados" className="block-content">
                    <div className="content-heading">
                        <h4 className="text-muted">Serviços Selecionados</h4>
                    </div>
                    <ul>
                        {selectedServices.map(service => (
                            <li key={service.id}>{service.name}</li>
                        ))}
                    </ul>
                </Tab>
                <Tab
                    eventKey="timeline"
                    title={`Timeline`}>

                    <div className="text-muted py-1">Timeline</div>
                    <ul class="timeline timeline-alt mt-0 mb-0" style={{ marginTop: -35 }}>
                        {timeline && timeline.map(item => (
                            <li className="timeline-event mt-2 mb-3">
                                <div class="media">
                                    <div className="mr-3 ml-3 overlay-container overlay-left">
                                        <span className="overlay-item item item-tiny item-circle border border-2x border-white bg-success"></span>
                                    </div>
                                    <div className="media-body ml-2">
                                        {item.description} <br />
                                        <small>
                                            <i className="si si-calendar mr-1" /> {item && DateTranslate(item.createdDate)}
                                        </small>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Tab>
            </Tabs>
            <ComplainEditModal
                show={showEditModal}
                onHide={() => setShowEditModal(false) | loadInfos()}
                infos={data && data}
            />
            <AdminCompanyModal
                show={showEditCompanyModal}
                onHide={() => setShowEditCompanyModal(false) | loadInfos()}
                company={data && data.company}
            />
        </Modal>
    );
}
